"use client";

import Image from "next/image";
import Link from "next/link";
import { useMemo } from "react";
import { Button } from "~components/ui";
import { type PageContext, getLinkProps } from "~lib/storyblok";
import { addUtm } from "~lib/tracking/helpers/add-utm";
import { getUtmParams } from "~lib/tracking/helpers/get-utm-params";
import agreenaLogo from "../../../../public/agreena-logo.svg";
import styles from "./simple-header-section.module.css";
import type { SimpleHeaderSectionBlok } from "./types";

type SimpleHeaderSectionProps = {
  blok: SimpleHeaderSectionBlok;
} & PageContext;

function SimpleHeaderSection({ blok, ...context }: SimpleHeaderSectionProps) {
  const utmParams = useMemo(
    () => getUtmParams(new URLSearchParams(context.searchParams ?? {})),
    [context],
  );

  return (
    <header className={styles.header}>
      <Link href={addUtm("/", utmParams)}>
        <Image
          className={styles.logoItem}
          src={agreenaLogo}
          height={28}
          alt="Agreena logo"
          unoptimized
        />
      </Link>

      {blok.ctaLabel && blok.ctaLink && (
        <div className="rounded-full bg-satellite-200 text-[white] transition duration-250 ease-in-out hover:bg-satellite-accent">
          <Button arrow={false} {...getLinkProps(blok.ctaLink, context)}>
            {blok.ctaLabel}
          </Button>
        </div>
      )}
    </header>
  );
}

export { SimpleHeaderSection };
